import { EMAIL_REGEX } from '../constants';

export const validateEmail = (email: string) => {
  return EMAIL_REGEX.test(email);
};

export const normalizeEmail = (email?: string | null) => {
  return email?.trim().toLowerCase() ?? '';
};

export const getFirstErrorMessage = (value: unknown) => {
  if (Array.isArray(value) && value.length > 0 && typeof value[0] === 'string') {
    return value[0];
  }

  if (typeof value === 'string') {
    return value;
  }

  return null;
};

export const getErrorMessageByPriority = (
  errorResponse: Record<string, unknown> | null | undefined,
  fallbackMessage: string,
  fieldPriority: string[]
) => {
  for (const fieldName of fieldPriority) {
    const message = getFirstErrorMessage(errorResponse?.[fieldName]);

    if (message) {
      return message;
    }
  }

  return fallbackMessage;
};
